import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { AuthRoutingModule } from './auth.routing';

import {
	NbCardModule,
	NbLayoutModule,
	NbInputModule,
	NbToastrModule,
	NbSpinnerModule,
	NbIconModule
} from '@nebular/theme';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordParentComponent } from './containers/forgot-password-parent/forgot-password-parent.component';
import { ResetPasswordParentComponent } from './containers/reset-password-parent/reset-password-parent.component';
import { LoginParentComponent } from './containers/login-parent/login-parent.component';

@NgModule({
	declarations: [
		LoginComponent,
		ForgotPasswordComponent,
		ResetPasswordComponent,
		ForgotPasswordParentComponent,
		ResetPasswordParentComponent,
		LoginParentComponent
	],
	imports: [
		CommonModule,
		AuthRoutingModule,
		ReactiveFormsModule,
		FormsModule,
		NbCardModule,
		NbLayoutModule,
		NbInputModule,
		NbIconModule,
		NbToastrModule.forRoot(),
		NbSpinnerModule
	]
})
export class AuthModule {}
